import { SendFlow } from './SendFlow';
import { COINS } from './TokenSheet';
import { useResendStore } from '../../store/resend';

/**
 * Global mount for the history "Resend" action. When a failed send's detail sheet
 * requests a resend, this opens the Send flow prefilled with the same recipient +
 * amount and a newly estimated retry — reusing all of SendScreen's confirm / reauth /
 * fee UI. Rendered once at the app root so it works from any history list.
 */
export function ResendMount() {
  const req = useResendStore((s) => s.req);
  const clear = useResendStore((s) => s.clear);
  if (!req) return null;
  const coin = COINS.find((c) => c.chain === req.chain && c.symbol === req.token);
  if (!coin) return null;
  return (
    <SendFlow
      coin={coin}
      prefill={{ to: req.to, amount: req.amount }}
      onClose={clear}
    />
  );
}
